import script from "./ContractGenerationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractGenerationView.vue?vue&type=script&setup=true&lang=js"

import "./ContractGenerationView.vue?vue&type=style&index=0&id=30fd029c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fd029c"]])

export default __exports__